module.exports = __webpack_public_path__ + "img/certTJ.e746fe8b.jpg";